import React, { useState } from "react";
import PropTypes from "prop-types";

// * Styles
import "../../../styles/chip.scss";
import { is } from "date-fns/locale";

const Chip = ({
  id,
  label,
  selected,
  size,
  selectable,
  onClick,
  previousValue,
  value,
  type,
  width = undefined,
  height = undefined,
  ...props
}) => {
  const [isSelected, setIsSelected] = useState(selected === true);
  // * Get class name
  let classNames = ["chip"];
  if (previousValue !== value && isSelected && type === "single") {
    setIsSelected(!isSelected);
  }
  if (isSelected) classNames.push("chip--selected");

  if (size) classNames.push(`chip--size-${size}`);

  // * Handle when clicking chip
  const handleClick = () => {
    // * Ignore if not selectable
    if (!selectable) return;

    const newIsSelectedValue = !isSelected;
    setIsSelected(newIsSelectedValue);

    // * Fire onClick event
    onClick(id, newIsSelectedValue);
  };

  return (
    <div
      className={classNames.join(" ")}
      onClick={handleClick}
      style={{ width: width ?? "auto", height: height ?? "auto" }}
    >
      {label}
    </div>
  );
};

Chip.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  selectable: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(["small", "medium", "large"]),
};

Chip.defaultProps = {
  selectable: true,
  onClick: () => {},
};

export default Chip;
